/**
 * PDP + featured product: on small viewports, replace the numeric gallery
 * counter with dot navigation (same behavior as the quick-add modal carousel).
 */
(function () {
  const MQ = window.matchMedia('(max-width: 749px)');

  function destroyDots(mg) {
    mg.querySelectorAll('.product__media-dots').forEach((el) => el.remove());
  }

  function buildForGallery(mg) {
    const list = mg.querySelector('.product__media-list, [id^="Slider-Gallery"]');
    if (!list) return;

    destroyDots(mg);

    const items = list.querySelectorAll('.product__media-item');
    if (items.length < 2 || !MQ.matches) return;

    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'product__media-dots';
    dotsContainer.setAttribute('role', 'tablist');
    dotsContainer.setAttribute('aria-label', 'Product images');

    const dotButtons = Array.from(items).map((item, idx) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'product__media-dot' + (idx === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to image ' + (idx + 1));
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
      dot.addEventListener('click', () => {
        const target = idx * list.clientWidth;
        list.scrollTo({ left: target, behavior: 'smooth' });
      });
      dotsContainer.appendChild(dot);
      return dot;
    });

    list.insertAdjacentElement('afterend', dotsContainer);

    const setActive = (idx) => {
      dotButtons.forEach((d, i) => {
        const active = i === idx;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              const idx = Array.prototype.indexOf.call(items, entry.target);
              if (idx !== -1) setActive(idx);
            }
          });
        },
        { root: list, threshold: [0.5, 0.75, 1] }
      );
      items.forEach((item) => observer.observe(item));
    } else {
      list.addEventListener(
        'scroll',
        () => {
          const idx = Math.round(list.scrollLeft / Math.max(list.clientWidth, 1));
          setActive(Math.min(Math.max(idx, 0), items.length - 1));
        },
        { passive: true }
      );
    }
  }

  function syncAll() {
    document.querySelectorAll('media-gallery').forEach((mg) => buildForGallery(mg));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  MQ.addEventListener('change', syncAll);
  document.addEventListener('shopify:section:load', syncAll);
  document.addEventListener('variant:change', function () {
    requestAnimationFrame(syncAll);
  });
})();
